import * as React from 'react';

const SvgStarFill = (props) => (
  <svg
    width={33}
    height={31}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.038 1.412a.5.5 0 0 1 .924 0l3.603 8.663a1.5 1.5 0 0 0 1.265.92l9.353.749a.5.5 0 0 1 .285.878l-7.126 6.104a1.5 1.5 0 0 0-.483 1.487l2.177 9.127a.5.5 0 0 1-.747.542l-8.007-4.89a1.5 1.5 0 0 0-1.564 0l-8.007 4.89a.5.5 0 0 1-.747-.542l2.177-9.127a1.5 1.5 0 0 0-.483-1.487l-7.126-6.104a.5.5 0 0 1 .286-.878l9.352-.75a1.5 1.5 0 0 0 1.265-.919l3.603-8.663Z'
      stroke='#ADADAD'
    />
  </svg>
);

export default SvgStarFill;
